const HOME_PATHS = new Set(['/', '/home']);

export const isHomePath = (pathname: string) => {
  const normalizedPathname = pathname.replace(/\/+$/, '') || '/';
  return HOME_PATHS.has(normalizedPathname);
};
